var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _circle, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYubikeyDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 94,
    viewBox: "0 0 62 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.375,
    y: 6.30029,
    width: 38.9625,
    height: 77.9251,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.67365,
    y: 7.59888,
    width: 36.365,
    height: 64.9376,
    rx: 1,
    fill: "#266ACA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.0638,
    y: 6.00134,
    width: 15.585,
    height: 5.195,
    rx: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6467 46.9077C50.0944 46.9077 49.6467 46.46 49.6467 45.9077L49.6467 36.9982C49.6467 36.4459 50.0944 35.9982 50.6467 35.9982L55.494 35.9982L55.494 46.9077L50.6467 46.9077Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6631 48.7261C46.9162 48.7261 45.5 47.3099 45.5 45.563L45.5 35.1801C45.5 34.6278 45.9477 34.1801 46.5 34.1801L48.115 34.1801C48.6673 34.1801 49.115 34.6278 49.115 35.1801L49.115 48.2742C49.115 48.5238 48.9127 48.7261 48.6631 48.7261V48.7261Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6 49.3323C26.2863 49.3323 23.6 46.646 23.6 43.3323L23.6 35.5741C23.6 34.4695 24.4954 33.5741 25.6 33.5741L47.6467 33.5741C48.7513 33.5741 49.6467 34.4695 49.6467 35.5741L49.6467 47.3323C49.6467 48.4368 48.7513 49.3323 47.6467 49.3323L29.6 49.3323Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.45 42.9254C32.45 43.7401 31.7896 44.4004 30.975 44.4004C30.1604 44.4004 29.5 43.7401 29.5 42.9254C29.5 42.1108 30.1604 41.4504 30.975 41.4504C31.7896 41.4504 32.45 42.1108 32.45 42.9254Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5163 51.2832V54.6213C13.5163 59.5919 17.5457 63.6213 22.5163 63.6213H26.5038",
    stroke: "#2EA76D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8338 49.9846V52.1277C19.8338 54.8892 22.0724 57.1278 24.8338 57.1278H26.9769",
    stroke: "#2EA76D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 72.5,
    r: 13.5,
    fill: "#D0021B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1633,
    y: 79.9033,
    width: 2.9299,
    height: 16.6028,
    rx: 1,
    transform: "rotate(-135 44.1633 79.9033)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42.0916,
    y: 68.1633,
    width: 2.9299,
    height: 16.6028,
    rx: 1,
    transform: "rotate(-45 42.0916 68.1633)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYubikeyDelete);
export default __webpack_public_path__ + "static/media/yubikey-delete.3025c3dab51ef41add473f0e4bfd1abc.svg";
export { ForwardRef as ReactComponent };